const Footer = () =>{

    return(
    <div>
        <table width="100%">
            <tbody>
            <tr>
            <td align="left" className="copyright">Copyright &copy; 2005 Central Media Group, Pearson Higher Education</td>
            </tr>
            </tbody>
        </table>
    </div>
    );
}

export default Footer;